export class GetUserQueue {
  static readonly type = '[Queue] GetUserQueue';
  constructor() { }
}

export class AddToUserQueue {
  static readonly type = '[Queue] AddToUserQueue';
  constructor(public borrowerId: number) { }
}

export class DeleteBorrowerFromUserQueue {
    static readonly type = '[Queue] DeleteBorrowerFromUserQueue';
    constructor(public borrowerId: number) {}
}

export class UpdateUserQueue {
  static readonly type = '[Queue] UpdateUserQueue';
  constructor(public borrowerIndex: number, public position: number) { }
}

export class ClearUserQueue {
    static readonly type = '[Queue] ClearUserQueue';
    constructor(public fullClear: boolean) {}
}
